import React from "react"
import { Transformation } from "cloudinary-react"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbSymbol from "../ui-kit/dfb_symbol"
import DfbImage from "../ui-kit/dfb_image"
import { conditionalLinkTarget } from "../utilities"

const CCardFactImage = ({
  image,
  type,
  icon,
  headline,
  layout,
  subline,
  description,
  anchor,
  href,
  linkObj
}) => {
  let headlineLevel = ""
  switch (type) {
    case "icon":
      headlineLevel = "h4"
      break
    case "headline":
      headlineLevel = "h3"
      break
    case "number":
    default:
      headlineLevel = "h1"
  }

  return (
    <a
      href={href}
      {...conditionalLinkTarget(href, linkObj)}
      className={`c-CardFactImage c-CardFactImage-card ${layout === "text-left" && "c-cardFactImage--reversed"}`}
    >
      {image?.src && (
        <div className="c-CardFactImage-proportionalWrapper">
          <div className="c-CardFactImage-image-container">
            <DfbImage
              image={image}
              aspect_ratio="16:9"
              add_class="c-CardFactImage-image"
            >
              <Transformation
                crop="fill"
                gravity="faces:center"
                width="1024"
                height="576"
                quality="auto"
                fetchFormat="auto"
              />
            </DfbImage>
            {image.copyright && (
              <div className="c-CardFactImage-image-copyright">
                {image.copyright}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="c-CardFactImage-content dfb-Card">
        {type === "icon" && icon && (
          <div className="c-CardFactImage-icon">
            <DfbSymbol icon_type={icon} />
          </div>
        )}

        {headline && (
          <DfbHeadline
            headline={headline}
            headline_level="h3"
            noLevelClass="true"
            add_class={`c-CardFactImage-headline dfb-Headline--${headlineLevel}`}
          />
        )}

        {subline && (
          <DfbHeadline
            headline={subline}
            headline_level="h4"
            noLevelClass="true"
            add_class="c-CardFactImage-subline dfb-Headline--h5"
          />
        )}

        {description && (
          <DfbParagraph
            text={description}
            add_class="c-CardFactImage-description"
          />
        )}

        {anchor && (
          <DfbAnchor
            tagName="div"
            text={anchor}
            secondary
            add_class="c-CardFactImage-anchor"
          />
        )}
      </div>
    </a>
  )
}

export default CCardFactImage
